/**
 * Frontend-only маппинг: ключ поля Product → PrimeIcons CSS класс.
 *
 * Backend (`backend/schemas/product_fields.py`) намеренно НЕ знает про иконки
 * — это снижает связанность бэка с UI.
 *
 * Для полей, у которых нет явной иконки, возвращается дефолт `pi pi-circle`.
 */

const ICONS = {
  // Системные
  id: 'pi pi-hashtag',
  status: 'pi pi-flag',
  last_modified: 'pi pi-clock',
  custom_fields: 'pi pi-cog',

  // Медиа
  images: 'pi pi-image',

  // Основные
  part_number: 'pi pi-barcode',
  part_name: 'pi pi-tag',
  brand: 'pi pi-bookmark',
  brand_cp: 'pi pi-bookmark-fill',
  model: 'pi pi-th-large',
  category: 'pi pi-folder',
  type: 'pi pi-list',
  condition: 'pi pi-shield',
  producer: 'pi pi-building',
  country: 'pi pi-globe',

  // Маркеры
  is_new: 'pi pi-star',
  is_bestseller: 'pi pi-trophy',
  is_rx: 'pi pi-eye',
  is_polarized: 'pi pi-sun',
  is_photochromic: 'pi pi-cloud',

  // Характеристики
  color: 'pi pi-palette',
  color_code: 'pi pi-hashtag',
  gender: 'pi pi-users',
  age: 'pi pi-user',
  shape: 'pi pi-circle',
  material: 'pi pi-box',
  year: 'pi pi-calendar',

  // Размеры
  size: 'pi pi-arrows-h',
  bridge: 'pi pi-arrows-h',
  temple_length: 'pi pi-arrows-h',
  lens_height: 'pi pi-arrows-v',

  // Прочее
  hs_code: 'pi pi-id-card',
  description: 'pi pi-file-edit',
  ai_description: 'pi pi-sparkles',
}

const DEFAULT_ICON = 'pi pi-circle'

/**
 * @param {string} fieldKey — ключ поля (`brand`, `bridge`, `custom:lens_width`, …)
 * @returns {string} CSS класс PrimeIcons
 */
export function getFieldIcon(fieldKey) {
  if (!fieldKey) return DEFAULT_ICON
  // Кастомные колонки имеют префикс `custom:` — для них общий fallback
  if (fieldKey.startsWith('custom:')) return 'pi pi-bolt'
  return ICONS[fieldKey] || DEFAULT_ICON
}
